import styled from 'styled-components';
import { D as DropdownDivider } from '../../Dropdown/DropdownDivider-3be7c2c0.js';
import { T as Text } from '../../Text/Text-f48a0c0d.js';

const StyledSelectOptionGroupHeader = /*#__PURE__*/styled(Text).attrs({
  type: 'span',
  textColor: 'tertiary'
}).withConfig({
  componentId: "sc-storm-ui-30051113__sc-1g82k13-0"
})(["userSelect:none;padding:1px 11px 0px 11px;font-weight:bold;font-size:", ";color:", ";text-transform:none;"], ({
  theme
}) => theme.typography.size.base, ({
  theme
}) => theme.dropdown.group.headingColor);
StyledSelectOptionGroupHeader.displayName = 'StyledSelectOptionGroupHeader';
const SelectOptionGroupContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30051113__sc-1g82k13-1"
})([":first-child ", "{display:none;};text-align:start;"], DropdownDivider);

export { SelectOptionGroupContainer as S, StyledSelectOptionGroupHeader as a };
//# sourceMappingURL=SelectOptionGroup.styles-5ec1b92a.js.map
